<template>
<div class="ChildrenorgManagement">
  <div class="mainContent" :style="styleObject">
    <div class="handles">
      <handles>
        <template v-slot:left>
          <!-- <el-select class="selectForm" v-model="keyWords.logType" placeholder="请选择日志类型" clearable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select> -->
          <el-input v-model="keyWord.par1" placeholder="昵称"></el-input>
          <el-input v-model="keyWord.par2" placeholder="登录名"></el-input>
          <el-input v-model="keyWord.par3" placeholder="联系方式"></el-input>
          <button v-if="rolePermit('tenant:query')" class="primaryBtn" @click="getTabList">搜索</button>
          <button v-if="rolePermit('tenant:add')" class="primaryBtn" @click="addItem">添加</button>
        </template>
        <!-- <template v-slot:right>
        </template> -->
          <!-- <el-button class="delSome" type="danger" plain icon="el-icon-delete" @click="deleteMonthRecord">清空一个月前记录</el-button> -->
      </handles>
    </div>
    <div class="tableBox">
      <border-table :tableData="dataList" :pages="pagination" :pageSizes="[10, 20, 50]" @currentChange="currentPageChange" @sizeChange="pageSizeChange" :loading="tableLoading">
        <el-table-column prop="id" label="ID" width="70" sortable></el-table-column>
        <el-table-column prop="nickName" label="租户昵称" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="loginName" label="租户登录名" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="tel" label="联系方式" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="email" label="邮箱地址" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" sortable></el-table-column>
        <el-table-column prop="isEnabled" label="是否启用" width="120" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.isEnabled" style="color:#28C6A2">正常</span>
            <span v-else style="color:#DD3071">禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="isLock" label="是否锁定" width="120" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.isLock" style="color:#DD3071">已锁定</span>
            <span v-else style="color:#28C6A2">未锁定</span>
          </template>
        </el-table-column>
        <el-table-column prop="lockExpiredTime" label="锁定到期时间" width="160" sortable show-overflow-tooltip></el-table-column>
        <el-table-column prop="comment" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" label="操作" width="360">
          <template slot-scope="scope">
            <el-button v-if="rolePermit('tenant:edit')" class="editBtn" type="text" icon="el-icon-edit-outline" @click="editItem(scope.row)">编辑</el-button>
            <el-button class="editPwdBtn" type="text" icon="el-icon-key" @click="modifyPwd(scope.row)">修改密码</el-button>
            <el-button style="color:#DD3071" class="delBtn" v-if="scope.row.isEnabled" type="text" icon="el-icon-unlock" @click="disabledTenant(scope.row)">禁用</el-button>
            <el-button class="delBtn" v-else type="text" icon="el-icon-unlock" @click="enabledTenant(scope.row)">启用</el-button>
            <el-button class="unlockBtn" v-if="scope.row.isLock" type="text" icon="el-icon-unlock" @click="unLockTenant(scope.row)">解锁</el-button>
            <el-button style="color:#DD3071" class="unlockBtn" v-else type="text" icon="el-icon-unlock" @click="lockTenant(scope.row)">锁定</el-button>
            <el-button style="color:#DD3071" v-if="rolePermit('tenant:del')" class="delBtn" type="text" icon="el-icon-delete" @click="delTent(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </border-table>
    </div>
  </div>
  <el-drawer :title="addOrEditPar.title" :modal="false" :visible.sync="addOrEditPar.show" :size="drawerWidth" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="addOrEditPar">
    <add-or-edit v-if="addOrEditPar.show" :addOrEditPar="addOrEditPar" :btnLoading="btnLoading" @changeWidth="changeWidth" @formSubmit="formSubmit"></add-or-edit>
  </el-drawer>
  <!-- <el-dialog :title="modifyPar.type === 'delete' ? '是否删除该租户' : '是否修改密码'" :visible.sync="modifyPar.show" :close-on-click-modal="false" @open='openEve' :width="modifyPar.type === 'delete'?'25%':'500px'" :before-close="handleClose">
    <el-form v-if="modifyPar.show" ref="modifyPar" :model="modifyPar" label-width="150px" :rules="psdRules" class="demo-ruleForm">
      <el-form-item :label="modifyPar.type === 'delete' ? '请输入管理员密码：' : '请输入租户新密码：' " prop="delPsd">
        <el-input type="password" v-model="modifyPar.delPsd" autocomplete="off" ref="focusEle" show-password></el-input>
      </el-form-item>
      <el-form-item v-if="modifyPar.type !== 'delete'" label="请重新输入新密码：" prop="delPsd">
        <el-input type="password" v-model="modifyPar.delPsd2" autocomplete="off" @blur="changePwd" show-password></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelEvent(modifyPar.type)">取 消</el-button>
      <el-button type="primary" @click="delItem">确 定</el-button>
    </span>
  </el-dialog> -->
  <!-- 修改密码 -->
  <el-dialog title="修改密码" :visible.sync="isSetPwdShow" :close-on-click-modal="false" @open='openEve' width="500px" :before-close="handleClose">
    <el-form ref="modifyPar" :model="modifyPar" label-width="150px" :rules="psdRules" class="demo-ruleForm">
      <el-form-item label="请输入租户新密码：" prop="delPsd">
        <el-input type="password" v-model="modifyPar.delPsd" autocomplete="off" ref="focusEle" show-password></el-input>
      </el-form-item>
      <el-form-item label="请重新输入新密码：" prop="delPsd" style="margin-top: 30px;">
        <el-input type="password" v-model="modifyPar.delPsd2" autocomplete="off" @blur="changePwd" show-password></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelEvent(modifyPar.type)">取 消</el-button>
      <el-button type="primary" @click="delItem">确 定</el-button>
    </span>
  </el-dialog>
</div>
</template>
<script>
var md5 = require("js-md5");
import BorderTable from "@/components/common/BorderTable";
import Handles from "@/components/common/Handles";
import AddOrEdit from '@/components/childOrgManagement/AddOrEdit'
import { checkKeyboardContinuousChar } from '@/utils/validate'
export default {
  components: {
    BorderTable,
    AddOrEdit,
    Handles
  },
  data() {
    return {
      // 表格======
      keyWord: {
        par1: '',
        par2: '',
        par3: ""
      },
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableLoading: false,
      // 表格======
      // 添加编辑====
      addOrEditPar: {
        title: "",
        show: false,
        row: {},
        type: ''
      },
      drawerWidth: "500px",
      // 添加编辑====
      // 修改密码删除
      modifyPar: {
        type: "",
        show: false,
        delPsd: '',
        delPsd2: '',
        delId: '',
      },
      timer: '',
      psdRules: {
        delPsd: [{
          required: true,
          validator: this.validatePasswd,
          trigger: "blur",
        }, ],
      },
      formFlagPwd: true,
      styleObject: {
        height: ''
      },
      btnLoading: false,
      isSetPwdShow: false,
    }
  },
  created() {
    this.getTabList();
    this.makeheight()
  },
  methods: {
    changePwd() {
      if (this.modifyPar.delPsd2 !== this.modifyPar.delPsd) {
        this.msg.warn('两次密码输入不一致，请重新输入')
        // return this.modifyPar.delPsd2 = ''
      } else {
        // return this.msg.success('两次密码输入一致')
      }
    },
    // 表格======
    async getTabList() {
      this.tableLoading = true
      let par = {
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        sort: 'createTime',
        order: 'desc',
        loginName: this.keyWord.par2,
        nickName: this.keyWord.par1,
        tel: this.keyWord.par3
      }
      const {
        code,
        data,
        total,
        msg
      } = await this.request.get('/front/system/tenant/query', par)
      console.log(data);

      this.tableLoading = false
      if (code !== 200) {
        if (code == 500) {
          return this.$message.error(msg)
        }
        return
      } else {
        this.pagination.total = total
        this.dataList = data
      }
    },
    currentPageChange(page) {
      this.pagination.currentPage = page;
      this.getTabList();
    },
    pageSizeChange(pageSize) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = pageSize;
      this.getTabList();
    },
    // 表格======
    // 添加======
    addItem() {
      this.addOrEditPar.show = true
      this.addOrEditPar.type = 'add'
      this.addOrEditPar.title = '添加'
      this.drawerWidth = "500px"
    },
    closeMess() {
      this.addOrEditPar.show = false;
    },
    changeWidth(width) {
      this.drawerWidth = width
    },
    async formSubmit(par) {
      this.btnLoading = true
      if (this.addOrEditPar.type == 'add') {
        par.pwd = md5(par.pwd)
        const {
          code,
          msg
        } = await this.request.postFormData('/front/system/tenant/add', par)
        if (code !== 200) {
          if (code == 500) {
            this.btnLoading = false
            return this.$message.error(msg)
          }
          return
        }
        this.getTabList()
        this.addOrEditPar.show = false
        this.drawerWidth = "500px"
        this.btnLoading = false
        return this.$message.success('添加成功')
      } else {
        const {
          code,
          msg
        } = await this.request.postFormData('/front/system/tenant/edit', par)
        if (code !== 200) {
          if (code == 500) {
            this.btnLoading = false
            return this.$message.error(msg)
          }
          return
        }
        this.getTabList()
        this.addOrEditPar.show = false
        this.drawerWidth = "500px"
        this.btnLoading = false
        return this.$message.success('编辑成功')
      }

    },
    // 添加======
    // 编辑======
    editItem(row) {
      this.addOrEditPar.show = true
      this.addOrEditPar.type = 'edit'
      this.addOrEditPar.row = row
      this.addOrEditPar.title = '编辑'
      this.drawerWidth = "500px"
    },
    // 添加======
    // 修改密码======
    openEve() {
      this.timer = setTimeout(() => {
        this.$refs['focusEle'].focus()
      }, 10)
    },
    handleClose() {
      clearTimeout(this.timer)
      this.modifyPar.delPsd = ''
      this.modifyPar.delPsd2 = ''
      this.modifyPar.show = false;
      this.isSetPwdShow = false
    },
    modifyPwd(row) {
      this.modifyPar.type = "change";
      this.modifyPar.show = true;
      this.isSetPwdShow = true
      this.modifyPar.delId = row.id;
    },
    async delItem() {
      this.$refs.modifyPar.validate(async (valid) => {
        if (valid) {
          if (this.modifyPar.delPsd !== this.modifyPar.delPsd2) {
            return this.$message.error('两次密码输入不一致，请重新输入')
          }
          const { code, msg } = await this.request.post("/front/system/tenant/changeTenantPwd?password=" + md5(this.modifyPar.delPsd), {
              password: md5(this.modifyPar.delPsd2),
              tenantId: this.modifyPar.delId
            })
          this.isSetPwdShow = false
          if (code !== 200) {
            this.modifyPar.show = false;
            this.modifyPar.delPsd = "";
            this.modifyPar.delPsd2 = "";
            // this.$message.error("修改密码错误，请联系管理员");
            if (code == 500) {
              return this.$message.error(msg)
            }
            return
          }
          this.modifyPar.show = false;
          this.modifyPar.delPsd = "";
          this.modifyPar.delPsd2 = "";
          return this.$message.success("修改密码成功");

        } else {
          this.$message.error("为了您的数据安全，请按照要求正确填写密码！")
        }
      })

      return
      if (this.modifyPar.type == "delete") {
        if (this.formFlagPwd) {
          // if (!this.modifyPar.delPsd) {
          //   return this.$message.error('管理员密码不能为空')
          // }
          const {
            code,
            data,
            msg
          } = await this.request.post("/front/system/tenant/del/" + this.modifyPar.delId
            //  {
            //   password: md5(this.modifyPar.delPsd),
            //   tenantId: this.modifyPar.delId,
            // }
          );
          console.log(code, data);

          if (code !== 200) {
            // this.delDialogVisible = false;
            this.modifyPar.delPsd = ''
            if (code == 500) {
              return this.$message.error(msg)
            }
            return
          } else {
            if (this.pagination.total > 1) {
              this.pagination.currentPage = (this.pagination.total - 1) % this.pagination.pageSize === 0 ? (this.pagination.currentPage - 1) : this.pagination.currentPage
            }
            this.getTabList();
            this.modifyPar.show = false;
            return this.$message.success("删除该租户成功");
            // console.log(data);
          }
        } else {
          // this.modifyPar.delPsd = "";
          return this.$message.error("输入的密码格式有误,请重新输入");
        }
        // -------------------删除功能
      } else {

        // 修改密码功能----------------------------------------
        if (this.modifyPar.delPsd !== this.modifyPar.delPsd2) {
          // this.formFlagPwd == false;
          // this.modifyPar.delPsd = "";
          // this.modifyPar.delPsd2 = "";
          return this.$message.error("两次输入的结果不同，请重新输入");
        } else {
          if (!this.modifyPar.delPsd) {
            return this.$message.error("租户新密码不能为空")
          }
        }
        // if (!(this.modifyPar.delPsd.length > 5 & this.modifyPar.delPsd.length < 21)) {
        //   this.modifyPar.delPsd = ''
        //   this.modifyPar.delPsd2 = ''
        //   return this.$message.warning('租户密码输入格式不正确,密码为6~20个字符')
        // }
        if (this.formFlagPwd) {
          (async () => {
            const {
              code,
              msg
            } = await this.request.post(
              "/front/system/tenant/changeTenantPwd?password=" + md5(this.modifyPar.delPsd), {
                password: md5(this.modifyPar.delPsd2),
                tenantId: this.modifyPar.delId,
              }
            );
            if (code !== 200) {
              this.modifyPar.show = false;
              this.isSetPwdShow = false
              this.modifyPar.delPsd = "";
              this.modifyPar.delPsd2 = "";
              // this.$message.error("修改密码错误，请联系管理员");
              if (code == 500) {
                return this.$message.error(msg)
              }
              return
            }
            this.modifyPar.show = false;
            this.modifyPar.delPsd = "";
            this.modifyPar.delPsd2 = "";
            return this.$message.success("修改密码成功");
          })();
        } else {
          this.modifyPar.delPsd = "";
          this.modifyPar.delPsd2 = "";
          return this.$message.error("输入的密码格式有误,请重新输入");
        }
      }
    },
    validatePasswd (rule, value, callback) {
      // 必须包含大小写字母、数字、特殊字符
      const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=_！]).+$/
      //不能相同字符（如111、aaa）连续3位或3位以上
      const regex1 = /(\w)*(\w)\2{2}(\w)*/g

      if (value === '') {
        callback(new Error('请输入租户密码'));
        this.formFlagPwd = false;
      } else if (value.length < 8 || value.length > 30) {
        callback(new Error('租户密码必须在8~30个字符之间'));
        this.formFlagPwd = false;
      } else if (!regex.test(value)) {
        callback(new Error('密码必须包含大小写字母、数字、特殊字符[!@#$%^&+=_]'))
        this.formFlagPwd = false;
      } else if (regex1.test(value)) {
        callback(new Error('密码不能含有相同字符（例如111、aaa）连续3位或3位以上'))
        this.formFlagPwd = false;
      } else if (checkKeyboardContinuousChar(value)) {
        callback(new Error('密码不能含有标准键相邻按键组合（例如ASDFG,QWERTY）'))
        this.formFlagPwd = false;
      } else {
        // 不能连续字符（如123、abc）连续3位或3位以上
        for (let i = 1; i < value.length - 1; i++) {
          let firstIndex = value[i - 1].charCodeAt()
          let secondIndex = value[i].charCodeAt()
          let thirdIndex = value[i + 1].charCodeAt()
          if ((thirdIndex - secondIndex == 1) && (secondIndex - firstIndex == 1)) {
            callback(new Error('密码禁止设置递增的字母或数字（例如abc,123）连续3位或3位以上!'))
            this.formFlagPwd = false;
          }
        }
        // if (this.editPwdform.newPasswordConfirm !== "") {
        //   this.$refs.editPwdform.validateField("newPasswordConfirm");
        //   this.formFlagPwd = false;
        // }
        callback()
        this.formFlagPwd = true
      }
    },
    // validatePasswd(rule, value, callback) {
    //   const reg = /(?=.*[A-Za-z])(?=.*[\d])(?=.*[~!@#$%^&*_])/

    //   if (value == undefined || value == "") {
    //     callback(new Error("请输入租户密码"));
    //     this.formFlagPwd = false;
    //   } else if (value.length < 8 || value.length > 30) {
    //     callback(new Error("租户密码必须在8~30个字符之间"));
    //     this.formFlagPwd = false;
    //   } else if (!reg.test(value)) {
    //     callback(new Error('密码必须包含字母、数字、特殊字符(~!@#$%^&*_)'))
    //     this.formFlagPwd = false;
    //   } else {
    //     callback();
    //     this.formFlagPwd = true;
    //   }
    // },
    cancelEvent(type) {
      this.msg.info(type === 'delete' ? '已取消删除' : '已取消修改密码')
      this.isSetPwdShow = false
      this.modifyPar.show = false
    },
    delTent(row) {
      // this.modifyPar.type = "delete";
      // this.modifyPar.show = true;
      // this.modifyPar.delId = row.id;
      this.$confirm('此操作将删除该租户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.post(`/front/system/tenant/del/${row.id}`).then(rs => {
          if (rs.code === 200) {
            if (this.pagination.total > 1) {
              this.pagination.currentPage = (this.pagination.total - 1) % this.pagination.pageSize === 0 ? (this.pagination.currentPage - 1) : this.pagination.currentPage
            }
            this.getTabList();
            this.msg.success('删除成功')
          } else {
            this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消操作')
      });
    },
    // 修改密码======
    // 禁用=====
    disabledTenant(row) {
      this.$confirm('此操作将禁用该租户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.post(`/front/system/tenant/disabled/${row.id}`).then(rs => {
          if (rs.code === 200) {
            this.getTabList();
            this.msg.success('操作成功')
          } else {
            this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消操作')
      });
    },
    // 禁用=====
    // 启用=====
    enabledTenant(row) {
      this.$confirm('此操作将启用该租户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.post(`/front/system/tenant/enabled/${row.id}`).then(rs => {
          if (rs.code === 200) {
            this.getTabList();
            this.msg.success('操作成功')
          } else {
            this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消操作')
      });
    },
    // 启用=====
    // 锁定====
    lockTenant(row) {
      this.$confirm('此操作将锁定该租户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.post(`/front/system/tenant/lock/${row.id}`).then(rs => {
          if (rs.code == 200) {
            this.getTabList();
            this.msg.success('操作成功')
          } else {
            this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消操作')
      });
    },
    unLockTenant(row) {
      this.$confirm('此操作将解锁该租户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.post(`/front/system/tenant/unlock/${row.id}`).then(rs => {
          if (rs.code == 200) {
            this.getTabList();
            this.msg.success('操作成功')
          } else {
            this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消操作')
      });
    },
    // 锁定====
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
  },
}
</script>

<style lang="scss" scoped>
.ChildrenorgManagement {
  height: 100%;

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
  }

  .handles {
    height: 50px;
  }
}
</style><style lang="scss">
.ChildrenorgManagement {
  .drawerWrap .drawerBody {
    padding: 0 35px;
  }

  .handleWrap .el-input {
    margin-right: 12px;
    margin-left: 0;
  }

  .handleWrap .primaryBtn {
    margin: 0;
    margin-right: 10px;
  }

  .el-dialog {
    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      top: 24px;
    }
  }
}
</style>
